export default "__VITE_ASSET__CXu8sGUH__"